module.exports = "<div class=\"accordion\">\r\n  <ng-content></ng-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/accordion/components/squeezebox.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/accordion/components/squeezebox.html
// module chunks = main